import styled from 'styled-components';
import {
  DatesGrid as OriginalDatesGrid,
  InlineError as BaseInlineError,
} from '../EditSegmentModal/styles';
import { Td as BaseTd } from '../../../display/tables/summaryTables/SummaryTablesStyles';
import { TableScroll as BaseTableScroll } from '../../../../pages/main/surveillanceRoute/components/SegmentList/styles';

// 14-oct (feedback del usuario: «la ui no me acaba de convencer»): el modal
// ancho de los modales de tabla, la caja lila de las tablas para la cabecera y
// el formulario, la tabla canónica (la misma hoja que Tramos) para las
// paradas, y los campos de «Corregir». Aquí solo se colocan; no se inventa
// ningún componente visual.
export {
  ButtonContainer,
  CloseButton,
  Container,
  EmptyMessage,
  MainButtonStyled,
} from '../RelateSegmentModal/styles';
export {
  FiltersContainer as LilacBox,
  Title as BoxTitle,
} from '../../../display/tables/components/MainStyledComponents';
export {
  FieldsGrid,
  InlineError,
  PkFieldWrap,
  TextAreaWrap,
  CrossingNotice as Notice,
  CrossingNoticeIcon as NoticeIcon,
} from '../EditSegmentModal/styles';
export {
  Table,
  Thead,
  Th,
  Td,
} from '../../../display/tables/summaryTables/SummaryTablesStyles';
// «Quitar» de una parada a mano: el mismo enlace que «Corregir» y «Parada»
// en la tabla de Tramos.
export {
  LinkText,
  SegmentRow as StopRow,
  TableScroll,
} from '../../../../pages/main/surveillanceRoute/components/SegmentList/styles';

/** Cargando mientras se guarda (mismo patrón que «Corregir»). */
export const ContainerLoader = styled.div`
  position: absolute;
  top: 40%;
  left: 50%;
  z-index: 1;
`;

export const Body = styled.div<{ $isLoading: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.m}rem;
  opacity: ${({ $isLoading }) => ($isLoading ? 0.6 : 1)};
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spaces.xs}rem;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spaces.s}rem;
  flex-wrap: wrap;
`;

/** Un campo del formulario: la etiqueta a la izquierda, encima del campo. */
export const Field = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spaces.xxs}rem;
  width: 100%;
  min-width: 0;
`;

/** La OT que se ligará, en la fila de su parada. */
export const LinkBadge = styled.span`
  color: ${({ theme }) => theme.colors.garnet};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;

/**
 * Llegada y salida una al lado de la otra (revisión del 22-oct). La rejilla de
 * «Corregir» reparte la fila a partes iguales, que en este modal ancho dejaba
 * la salida en mitad de la pantalla, lejos de su llegada. Mismos campos y
 * mismos anchos: solo se juntan, y bajan a otra línea si no caben.
 */
export const DatesGrid = styled(OriginalDatesGrid)`
  display: flex;
  flex-wrap: wrap;
  column-gap: 4rem;
`;

/**
 * La tabla de paradas sin alto máximo propio (revisión del 22-oct): con la
 * tarjeta de la parada dentro, su scroll quedaba dentro del del modal. Y sus
 * celdas (no las cabeceras) parten línea, para no salirse de lado en tablet
 * vertical.
 */
export const StopTableScroll = styled(BaseTableScroll)`
  max-height: none;

  td {
    white-space: normal;
  }

  /* En tablet las cabeceras también parten línea: con «Posición en el tramo»
     en una sola, a 800 px la tabla se salía de lado y la tarjeta de la parada,
     que va dentro, quedaba cortada por la derecha. */
  @media (max-width: ${({ theme }) =>
      theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    th {
      white-space: normal;
    }
  }
`;

/**
 * Lo de dentro de la fila de la tarjeta no cuenta para el ancho de la tabla
 * (`width: 0` + `min-width: 100%`): ocupa lo que mida la tabla, sin ensanchar
 * sus columnas ni empujarla fuera del modal en tablet vertical.
 */
export const FormCellBody = styled.div`
  width: 0;
  min-width: 100%;
`;

/**
 * La fila de la tarjeta: ocupa todo el ancho y deja el mismo aire arriba que
 * abajo. Arriba hacía de separación la fila del aviso «Indica la causa…»; sin
 * ella la tarjeta quedaba pegada a su fila (revisión del 27-oct).
 */
export const FormCell = styled(BaseTd)`
  /* &&& (30-oct): la celda base da otro relleno y width 0 a la que contiene un
     radio o una casilla (celdaDeSelector), y la tarjeta de una parada en medio
     tiene los radios del sentido. Con && ganaba aquella regla y esas tarjetas
     salían sangradas respecto a la de «al inicio». */
  &&& {
    width: auto;
    padding: ${({ theme }) => theme.spacing.xs} 0;
  }
`;

/**
 * El aviso de una parada, dentro de su tarjeta (revisión del 23-oct): a la
 * izquierda, con los campos. El de «Corregir» va centrado porque allí está
 * suelto al pie del modal.
 */
export const CardError = styled(BaseInlineError)`
  text-align: left;
`;
